import { createContext } from 'react';

const value = {
  followedBrands: [],
  availableBrands: [],
  toggleFollowBrand() {
    // eslint-disable-next-line no-console
    console.warn('UserContext.toggleFollowBrand not implemented');
  },
  isBrandFollowedByUser() {
    // eslint-disable-next-line no-console
    console.warn('UserContext.isBrandFollowedByUser not implemented');
    return undefined;
  },
  setAvailableBrands() {
    // eslint-disable-next-line no-console
    console.warn('UserContext.setAvailableBrands not implemented');
  },
};

export const FollowBrandContext = createContext(value);
